import { render, staticRenderFns } from "./footer-nav.vue?vue&type=template&id=1b1e6d14&scoped=true&"
import script from "./footer-nav.vue?vue&type=script&lang=js&"
export * from "./footer-nav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b1e6d14",
  null
  
)

export default component.exports